import rp from 'request-promise';

export default class Gatekeeper {

  constructor(user, endpoints) {
    this.user = user;
    this.endpoints = endpoints;
    this.headers = {
      'X-Folksy-User-ID': this.user.id,
      'X-Folksy-User-Token': this.user.token,
    };
  }

  getData(itemId) {
    return rp({
      uri: this.endpoints.itemCustomisationData(itemId),
      headers: this.headers,
      json: true,
    })
      .json()
  }

  saveData(itemId, customisations) {
    return rp({
      uri: this.endpoints.itemCustomisationData(itemId),
      method: 'PUT',
      headers: this.headers,
      body: { customisations: customisations },
      json: true,
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/item-customisations/gatekeeper.js